import useScrollReveal from '../hooks/useScrollReveal';

export default function CTA() {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="cta">
      <div className="cta-bg"></div>
      <div className="cta-ring"></div>
      <div className="cta-ring"></div>
      <div className="cta-ring"></div>
      <div className={`cta-content reveal ${isVisible ? 'visible' : ''}`} ref={ref}>
        <h2 className="cta-title">
          Rejoignez TIGOO<br />dès aujourd'hui
        </h2>
        <p className="cta-sub">
          Que vous cherchiez les meilleurs coupons ou que vous souhaitiez partager votre talent, TIGOO est fait pour vous.
        </p>
        <div className="cta-buttons">
          <a href="#" className="btn-primary btn-lg">Accéder à l'app gratuitement →</a>
        </div>
      </div>
    </section>
  );
}
